import { useDisclosure } from '@chakra-ui/react';
import { CompositionMaterial } from '@texas/api/endpoints/compositionApi';
import { CreateCompositionMaterial } from '@texas/components/shared/composition/material/CreateCompositionMaterial';
import { useTranslation } from 'react-i18next';
import { EmptyDataButton } from '../../button/EmptyDataButton';
import { MaterialFormType } from '@texas/components/shared/composition/material/CompositionMaterialForm';

export function AddMaterial({
  compositionId,
  productGroupId,
  subTitle,
  onCreated,
  formType,
  isReady,
  groupHasAnyBasedOn,
  vdcTemplate,
}: {
  compositionId: number;
  productGroupId: number | null;
  subTitle?: string;
  formType?: MaterialFormType;
  isReady: boolean;
  groupHasAnyBasedOn: boolean;
  onCreated: (data: CompositionMaterial) => void;
  vdcTemplate: boolean;
}) {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { t } = useTranslation();
  return (
    <>
      <CreateCompositionMaterial
        formType={formType}
        onCreated={onCreated}
        compositionId={compositionId}
        productGroupId={productGroupId}
        isOpen={isOpen}
        onClose={onClose}
        subTitle={subTitle}
        isReady={isReady}
        groupHasAnyBasedOn={groupHasAnyBasedOn}
        vdcTemplate={vdcTemplate}
      />
      <EmptyDataButton
        label={t('materials.add')}
        description={t('materials.addMaterialDesc')}
        onClick={onOpen}
      />
    </>
  );
}
